<div class="app-component-container costum-mat-primary-container" id="reviews">
    <div class="content">
        <app-s-header [elemIds]="elementSignals['component-header']()"></app-s-header>
    </div>
    <base-app-reviews ngSkipHydration></base-app-reviews>
</div>